import ListadoNotas from "./ListadoNotas.vue";
import FormNota from "./FormNota.vue";

export default [
  {
    path: "/notas",
    name: "notas",
    component: ListadoNotas,
    meta: {
      titulo: "Mis notas",
      icono: "fal fa-fw fa-sticky-note",
    },
  },
  {
    path: "/notas/nota/:id",
    name: "nota",
    component: FormNota,
    meta: {
      titulo: "Nota",
      icono: "fal fa-fw fa-sticky-note",
      esconder: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/notas/rutas.js